// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateTagRequestModel from '../../model/update-tag-request-model';
import UpdateTagRequestDTO from '../dto/update-tag-request-dto';
import dtoSchema from '../schemas/update-tag-request-schema';

export default abstract class UpdateTagRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateTagRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.caption = data.caption ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  caption?: string;

  static toModel(dto: DeepPartial<UpdateTagRequestDTO>): UpdateTagRequestModel;
  static toModel(dto: DeepPartial<UpdateTagRequestDTO> | undefined | null): UpdateTagRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateTagRequestDTO> | undefined | null): UpdateTagRequestModel | undefined {
    return dto ? new UpdateTagRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateTagRequestModel> | UpdateTagRequestModel): UpdateTagRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      caption: unwrapped.caption,
    } as UpdateTagRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateTagRequestModel, can not map to UpdateTagRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
